// extracted by mini-css-extract-plugin
module.exports = {"barCode":"printBarCode_barCode__2tfxY"};